import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/fd/bill-prepare",
        component: List,
        name: "fd.bill.prepare.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/bill-prepare/create",
        component: Create,
        name: "fd.bill.prepare.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/bill-prepare/:id/edit",
        component: Edit,
        name: "fd.bill.prepare.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/bill-prepare/:id/view",
        component: Create,
        name: "fd.bill.prepare.view",
        meta: {
            requiresAuth: true,
        },
    },
];
